// extracted by mini-css-extract-plugin
export default {"container":"TagManager_container__-G53L","column":"TagManager_column__6Pn3Z","box":"TagManager_box__bkjD9","spacer":"TagManager_spacer__MDYyb"};